import { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

export const fadeInUp = keyframes`
  0% {
    opacity: 0;
    top: 100%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
`;

export const fadeOutDown = keyframes`
0% {
  opacity: 1;
  top: 50%;
}
  100% {
    opacity: 0;
    top: 100%;
  }
`;

export const slideInUp = keyframes`
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0%);
  }
`;

export const slideOutDown = keyframes`
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(100%);
  }
`;

export const slideInLeft = keyframes`
0% {
  transform: translateX(100%);
}
100% {
  transform: translateX(0%);
}
`;

export const slideOutRight = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
`;
